(() => {
  if (window.__appliCourseCartGuardLoaded) return;
  window.__appliCourseCartGuardLoaded = true;

  const COURSE_FORM_SELECTOR = 'product-form-component[data-appli-course-product="true"] form, quick-add-component[data-appli-course-product="true"] form, form[data-appli-course-product="true"]';
  const CART_URL = window.Theme?.routes?.cart_url || '/cart';
  const CART_ADD_URL = window.Theme?.routes?.cart_add_url || '/cart/add.js';
  const CHECKOUT_URL = '/checkout';
  let cartPromise = null;
  let toastTimer = null;
  let isAdding = false;

  function getCart() {
    if (!cartPromise) {
      cartPromise = fetch('/cart.js', { credentials: 'same-origin' })
        .then((response) => response.json())
        .catch(() => null)
        .finally(() => {
          setTimeout(() => { cartPromise = null; }, 500);
        });
    }
    return cartPromise;
  }

  function normalizeQuantity(form) {
    let quantityInput = form.querySelector('[name="quantity"]');
    if (!quantityInput) {
      quantityInput = document.createElement('input');
      quantityInput.type = 'hidden';
      quantityInput.name = 'quantity';
      form.appendChild(quantityInput);
    }
    quantityInput.value = '1';
    quantityInput.setAttribute('max', '1');
    quantityInput.setAttribute('min', '1');
    quantityInput.dataset.appliCourseQuantity = 'true';
  }

  function getVariantId(form) {
    const input = form.querySelector('[name="id"]');
    return input?.value ? String(input.value) : '';
  }

  function getProductTitle(form) {
    return form.dataset?.appliProductTitle ||
      form.closest('product-form-component')?.dataset?.appliProductTitle ||
      form.closest('quick-add-component')?.dataset?.productTitle ||
      'Este curso';
  }

  function isBuyNowForm(form) {
    return form.dataset?.appliCourseBuyNow === 'true' || Boolean(form.querySelector('[data-appli-hero-buy-now]'));
  }

  function showToast(message, options = {}) {
    let toast = document.querySelector('[data-appli-course-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.setAttribute('data-appli-course-toast', '');
      toast.className = 'appli-course-toast';
      toast.innerHTML = `
        <div class="appli-course-toast__icon" aria-hidden="true">✓</div>
        <div class="appli-course-toast__body">
          <strong class="appli-course-toast__title">Curso agregado</strong>
          <p class="appli-course-toast__message"></p>
        </div>
        <a class="appli-course-toast__action" href="${CART_URL}">Ver carrito</a>
        <button class="appli-course-toast__close" type="button" aria-label="Cerrar">×</button>
      `;
      document.body.appendChild(toast);
      toast.querySelector('.appli-course-toast__close')?.addEventListener('click', () => hideToast());
    }

    toast.querySelector('.appli-course-toast__message').textContent = message;
    if (options.title) toast.querySelector('.appli-course-toast__title').textContent = options.title;
    toast.classList.add('is-visible');

    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => hideToast(), 5500);
  }

  function hideToast() {
    const toast = document.querySelector('[data-appli-course-toast]');
    toast?.classList.remove('is-visible');
  }

  async function courseAlreadyInCart(variantId) {
    if (!variantId) return false;
    const cart = await getCart();
    return Boolean(cart?.items?.some((item) => String(item.variant_id) === String(variantId)));
  }

  function getCartSectionIds() {
    const ids = [];
    document.querySelectorAll('cart-items-component').forEach((item) => {
      if (item instanceof HTMLElement && item.dataset.sectionId) ids.push(item.dataset.sectionId);
    });
    return ids;
  }

  async function addCourseToCart(form) {
    if (isAdding) return;
    isAdding = true;

    normalizeQuantity(form);
    const variantId = getVariantId(form);
    const title = getProductTitle(form);
    const buyNow = isBuyNowForm(form);

    if (!variantId) {
      isAdding = false;
      showToast('No pudimos identificar la variante del curso. Refresca la página e intenta nuevamente.', { title: 'No se pudo agregar' });
      return;
    }

    const alreadyInCart = await courseAlreadyInCart(variantId);
    if (alreadyInCart) {
      isAdding = false;
      if (buyNow) {
        window.location.href = CHECKOUT_URL;
        return;
      }
      showToast(`${title} ya está en tu carrito. Para cursos digitales solo permitimos 1 acceso por pedido.`, {
        title: 'Este curso ya está en tu carrito'
      });
      return;
    }

    const formData = new FormData(form);
    formData.set('id', variantId);
    formData.set('quantity', '1');

    const sectionIds = getCartSectionIds();
    if (sectionIds.length) formData.set('sections', sectionIds.join(','));

    try {
      const response = await fetch(CART_ADD_URL, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
        credentials: 'same-origin'
      });
      const data = await response.json();

      if (!response.ok || data.status) {
        showToast(data?.message || 'No pudimos agregar el curso al carrito. Intenta nuevamente.', { title: 'No se pudo agregar' });
        return;
      }

      cartPromise = null;
      const cart = await getCart();

      if (buyNow) {
        showToast(`${title} fue agregado correctamente. Te llevamos al checkout.`, { title: 'Curso agregado' });
        setTimeout(() => { window.location.href = CHECKOUT_URL; }, 450);
        return;
      }

      showToast(`${title} fue agregado correctamente.`, { title: 'Curso agregado al carrito' });

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'appli-course-cart-guard',
          data: {
            source: 'product-card',
            openCartDrawer: true,
            itemCount: 1,
            variantId,
            sections: data.sections || {}
          }
        }
      }));
    } catch (error) {
      console.warn('[APPLI] Error agregando curso:', error);
      showToast('No pudimos agregar el curso al carrito. Revisa tu conexión e intenta nuevamente.', { title: 'No se pudo agregar' });
    } finally {
      isAdding = false;
    }
  }

  async function clampCourseCartLines() {
    const lines = document.querySelectorAll('.appli-course-cart-line[data-appli-course-line]');
    for (const line of lines) {
      const lineNumber = Number(line.dataset.appliCourseLine);
      const displayedQty = Number(line.dataset.appliCourseQuantity || 1);
      const fixed = line.querySelector('.appli-course-cart-fixed-quantity__value');
      if (fixed) fixed.textContent = '1';
      if (displayedQty > 1 && lineNumber) {
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line: lineNumber, quantity: 1 }),
            credentials: 'same-origin'
          });
          window.location.reload();
          return;
        } catch (error) {
          console.warn('[APPLI] No se pudo ajustar la cantidad del curso:', error);
        }
      }
    }
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches(COURSE_FORM_SELECTOR)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    addCourseToCart(form);
  }, true);

  document.addEventListener('click', (event) => {
    const button = event.target.closest('product-form-component[data-appli-course-product="true"] .quantity-plus, form[data-appli-course-product="true"] .appli-course-hero__quantity button[aria-label*="Aumentar"]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    showToast('Para cursos digitales la cantidad está limitada a 1 acceso por pedido.', {
      title: 'Cantidad máxima: 1'
    });
  }, true);

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (!input.matches('[data-appli-course-quantity], product-form-component[data-appli-course-product="true"] [name="quantity"], form[data-appli-course-product="true"] [name="quantity"]')) return;
    input.value = '1';
  }, true);

  document.addEventListener('DOMContentLoaded', clampCourseCartLines);
  document.addEventListener('cart:update', clampCourseCartLines);
})();
